// 常量
import * as constants from 'js/constants/index'
// 工具方法
import * as utils from 'js/utils/index'

import { getImgUrl } from './getImgUrl'

/**
 * 查看大图。使用前必须在html文件中引入viewer.min.js。
 * @param {Object} wrapper img 标签的父元素
 * @return {Object | Boolean} 成功 Viewer 对象; 失败 false。
 */
export function init (options = {}) {
  options = Object.assign({}, options)

  if (!(argsInit(options) && argsValidate(options))) {
    return false
  }

  let {
    wrapper,
  } = options

  // 指定大图 src 为小图的 data-original
  let viewer = new Viewer(wrapper, {
    url: constants.propertyName.viewer.hdUrl,
  })

  return viewer
}

/**
 * 参数初始化
 */
function argsInit (options = {}) {
  let from = '[viewer][init]'

  if (!utils.args.init.selector({
    args: options,
    from,
    name: 'wrapper',
  })) {
    return false
  }

  return true
}

/**
 * 参数校验
 */
function argsValidate (options = {}) {
  let from = '[viewer][init]'

  if (!utils.args.validate.instance({
    args: options,
    from,
    name: 'wrapper',
  })) {
    return false
  }

  return true
}


// WEBPACK FOOTER //
// ./js/animation/viewer/init.js